import React from "react";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import Map from './Map';
import {GeolocationProps} from "./GeolocationLayer"
import {MarkersProps} from "./MarkersLayer"
import {ControlsProps} from "./ControlsLayer"
import {ContentProps} from "./ContentLayer"
import {MonitorProps} from "./MonitorLayer"

import './Map.css'

const renderMapStatus = (status: Status) => {
    return <h1>{status}</h1>;
};

const MapWrapper: React.FC<{
        onClickHandler?: (event: google.maps.MapMouseEvent)=>void
        geolocation?: GeolocationProps                         
        markers?: MarkersProps
        controls?: ControlsProps
        content?: ContentProps
        monitor?: MonitorProps
        }> = (props) => {
    const API_KEY = "AIzaSyAfLcweFJT6DAteA9_zHUZy-tZaxbtEt-M";
    const MAP_ID = 'e77b4090a087ed3b';
    return (
        <div style={{ width: "100%", height: "100%"}}>
            <Wrapper apiKey={API_KEY} /*render={renderMapStatus}*/>
                <Map mapId={MAP_ID}
                     onClickHandler={props.onClickHandler}
                     geolocation={props.geolocation}
                     markers={props.markers}
                     controls={props.controls}
                     content={props.content}
                     monitor={props.monitor}
                />
            </Wrapper>
        </div>
    );
};

export default MapWrapper;